<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fa fa-car"></i>&nbsp;Galeria</h1>
		</div>
		<div class="mt-3">
			<button id="agregarBoton" mat-raised-button class="btn btn-success" (click)="imprimirGaleria()"
				[hidden]="true"><i class="far fa-file-pdf"></i>&nbsp;Imprimir</button>&nbsp;
			<button id="agregarBoton" mat-raised-button class="btn btn-success" (click)="obtenerVehiculos()"><i
					class="fas fa-sync-alt"></i>&nbsp;Refrescar</button>&nbsp;
			<button mat-raised-button (click)="regresar()"><i
					class="fas fa-long-arrow-alt-left"></i>&nbsp;Regresar</button>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div class="kt-portlet__body">
		<div class="row" [hidden]="loading" id="cards">
			<div *ngIf="!listaImagenes.length">
				Sin imagenes disponibles
			</div>
			<div class="col-md-2" *ngFor="let imagen of listaImagenes">
				<mat-card>
					<img [src]="imagen.url">
					<div class="mt-2 fecha">
						<i class="fal fa-calendar-day"></i>&nbsp;
						<span>Fecha:&nbsp;</span>
						<span>{{imagen.fecha}}</span><br>
						<i class="fal fa-barcode"></i>&nbsp;
						<span>Economico:&nbsp;</span>
						<span>{{imagen.economico}}</span>
					</div>
				</mat-card>
			</div>
		</div>
		<mat-card [hidden]="!loading" class="loading">
			<mat-progress-spinner color="primary" mode="indeterminate">
			</mat-progress-spinner>
		</mat-card>
	</div>
</div>




<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
